let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7uYFt")).then(() => parcelRequire('aHZwu'));